export const fontFamily =
  'var(--font-instrument-sans), "Instrument Sans", ui-sans-serif, system-ui, sans-serif';
